import { render, staticRenderFns } from "./StockSection.vue?vue&type=template&id=715852bf&scoped=true&"
import script from "./StockSection.vue?vue&type=script&lang=js&"
export * from "./StockSection.vue?vue&type=script&lang=js&"
import style0 from "./StockSection.vue?vue&type=style&index=0&id=715852bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715852bf",
  null
  
)

export default component.exports